import { layout } from 'thewest/App.routing'
import { Product } from 'component-library/__product'

export const telethonCountdown = layout.nestedComposition({
    type: 'box',
    props: {
        verticalSpacing: 'lg',
    },
    contentAreas: {
        main: [
            layout.component({
                type: 'telethon-countdown',
                feature: 'telethon-countdown',
                props: { product: Product.TheWest },
            }),
        ],
    },
})
